<template>
    <ul class="timeline">
        <TimelineItem
            v-for="(item, index) in items" 
            :key="item.id || index"
            :item="item"
            :item-type="itemType"
        >
        </TimelineItem>
    </ul>
</template>

<script>
import TimelineItem from './TimelineItem.vue';

export default {
    name: 'Timeline',
    components: { TimelineItem },
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemType: {
            type: String,
        }
    },
    data() {
        return {};
    },
}
</script>
